module.exports = require("react-ace");